import config from '@/config'
import Api from '@/helpers/api'
import ExampleGetOrders from './Placeholders/GetOrders.json'
import ExampleGetOrder from './Placeholders/GetOrder.json'
import ExamplePostAssign from './Placeholders/PostAssign.json'

export default {
  /**
   * Return list of orders grouped by day
   *
   * @returns {Promise}
   */
  getOrders () {
    return Api.get(`${config.api_url}/v4/mpo/orders`, ExampleGetOrders)
  },

  /**
   * Return order details
   *
   * @param {Number} id
   * @returns {Promise}
   */
  getOrder (id) {
    return Api.get(`${config.api_url}/v4/mpo/orders/${id}`, ExampleGetOrder)
  },

  /**
   * Assign courier|picker and driver to order
   *
   * @param {Number} id
   * @param {Object} data
   * @returns {Promise}
   */
  assignCourier (id, data) {
    return Api.post(`${config.api_url}/v4/mpo/orders/${id}/assign`, data, ExamplePostAssign)
  }
}
